module.exports = __webpack_public_path__ + "img/wf-background.edbc91e9.jpg";